import { Editor, Frame, SerializedNodes, useEditor } from "@craftjs/core";
import { ReactNode, useEffect, useRef } from "react";
import "./assets/page-editor.css";
import RegionManager from "./components/RegionManager";
import RenderNode from "./components/RenderNode";
import { resolver } from "./resolver";

interface PageEditorProps {
    children?: ReactNode;
    data?: string | SerializedNodes;
    slug?: string;
}

const PageViewer = ({ children, data }: PageEditorProps) => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [data]);

    return (
        <div id="page-editor-content-container">
            <RegionManager />
            <Editor resolver={resolver} enabled={false} onRender={RenderNode}>
                {children}

                <PageViewerFrame data={data} />
            </Editor>
        </div>
    );
};

const PageViewerFrame = ({ data }: { data: string | SerializedNodes | undefined }) => {
    const { actions } = useEditor();
    const mountedDataRef = useRef<string | undefined>(undefined);

    useEffect(() => {
        if (!data) return;
        const json = typeof data === "string" ? data : JSON.stringify(data);
        if (mountedDataRef.current === json) return; // already loaded
        mountedDataRef.current = json;
        actions.deserialize(json);
    }, [data, actions]);

    return <Frame />;
};

export default PageViewer;
